// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-object-UserListLabel-UserListLabel-module__box--yyhj6 * {
  display: inline;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-UserListLabel-UserListLabel-module__multiple--ob8H_ {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/object/UserListLabel/UserListLabel.module.less"],"names":[],"mappings":"AAAA;EAEI,eAAA;AAAJ;AAGA;EACE,WAAA;AADF","sourcesContent":[".box {\n  * {\n    display: inline;\n  }\n}\n.multiple {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-common-attributes-makeAttrLabel-labelMakers-object-UserListLabel-UserListLabel-module__box--yyhj6`,
	"multiple": `src-common-attributes-makeAttrLabel-labelMakers-object-UserListLabel-UserListLabel-module__multiple--ob8H_`
};
export default ___CSS_LOADER_EXPORT___;
